import React, { useState, useContext } from "react";
import PropTypes from "prop-types";

import PrRepresentativeSelect from "../pr_representative_select";
import SaveSpinnerButton from "../../edit/save_spinner_button";
import { ProductContext } from "../../data/product_context_management";

function AddRepresentativeForm({ onAsyncError, isUpdating, onAdd, setIsEditing }) {
  const { product } = useContext(ProductContext);
  const [selectedOption, setSelectedOption] = useState();

  return (
    <div className="container" aria-label="Add a Representative">
      <div
        className="row justify-content-between"
        style={{
          borderRadius: "10px",
          boxShadow: "1px 1px 20px 1px rgba(0, 0, 0, 0.05)",
          padding: "1em",
        }}
      >
        <label htmlFor="add-representative-select" className="form-label small mb-2">
          Add a representative
        </label>
        <div className="mb-2">
          <PrRepresentativeSelect
            inputId="add-representative-select"
            value={selectedOption}
            isMulti={false}
            excludeIds={product.representative_profile_ids}
            onAsyncError={onAsyncError}
            onChange={(option) => {
              setSelectedOption(option);
            }}
          />
        </div>
        <div>
          <SaveSpinnerButton
            inactiveText="Add"
            activeText="Adding..."
            isSaving={isUpdating}
            className="btn btn-primary btn-sm"
            onClick={async () => {
              // The form closes only once the add landed: a failed write keeps the selection here,
              // with the card's error alert explaining why, instead of vanishing silently.
              const added = await onAdd(selectedOption?.value);
              if (added === false) return;
              setIsEditing(false);
              setSelectedOption(null);
            }}
          />
          <button
            type="button"
            className="btn btn-link"
            onClick={() => {
              setIsEditing(false);
              setSelectedOption(null);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

AddRepresentativeForm.propTypes = {
  onAsyncError: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  setIsEditing: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool.isRequired,
};

export default AddRepresentativeForm;
